// Approved illustration set (T&P1/final png), resized to 640px and encoded as
// WebP: 9.6 MB of source PNG becomes ~356 KB, which matters because these sit
// on empty states — the screens a user hits most often when they have no data
// yet, and the worst possible place to download a 650 KB image.
//
// Imported through Vite so every file is content-hashed and cache-busted.
import booking from './booking.webp';
import consultation from './consultation.webp';
import discoverDoctors from './discover-doctors.webp';
import emptyHistory from './empty-history.webp';
import emptyList from './empty-list.webp';
import family from './family.webp';
import fileUpload from './file-upload.webp';
import loginError from './login-error.webp';
import notFound from './not-found.webp';
import pharmacy from './pharmacy.webp';
import profileSetup from './profile-setup.webp';
import securePayment from './secure-payment.webp';
import selectDateTime from './select-date-time.webp';
import settingsPrivacy from './settings-privacy.webp';
import success from './success.webp';
import videoCall from './video-call.webp';

// Named exports so a screen can pull in exactly the one it needs and the rest
// stay tree-shakeable, plus the grouped object for anything that wants to pick
// dynamically.
export {
    booking,
    consultation,
    discoverDoctors,
    emptyHistory,
    emptyList,
    family,
    fileUpload,
    loginError,
    notFound,
    pharmacy,
    profileSetup,
    securePayment,
    selectDateTime,
    settingsPrivacy,
    success,
    videoCall,
};

export const illustrations = {
    booking,
    consultation,
    discoverDoctors,
    emptyHistory,
    emptyList,
    family,
    fileUpload,
    loginError,
    notFound,
    pharmacy,
    profileSetup,
    securePayment,
    selectDateTime,
    settingsPrivacy,
    success,
    videoCall,
};

export default illustrations;
